<template>
  <div class="container">
    <div class="heading">统一登录失败</div>
    <p class="desc">{{ description }}</p>
    <div v-if="reasonText" class="detail">原因：{{ reasonText }}</div>
    <div v-if="messageText" class="detail">说明：{{ messageText }}</div>
    <a-button type="primary" size="large" class="login-button" @click="retry">
      重新发起登录
    </a-button>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { clearGatewayRedirectFlag, redirectToGatewayLogin } from '@/utils/auth'

export default defineComponent({
  name: 'GatewayLoginFailed',
  setup() {
    const route = useRoute()
    const reasonText = computed(() => route.query.reason || '')
    const messageText = computed(() => route.query.message || '')
    const description = computed(() => {
      if (messageText.value) return '统一认证未完成，前端收到了失败信息。'
      return '统一认证后仍未建立有效会话，请重新发起登录。'
    })
    const retry = () => {
      clearGatewayRedirectFlag()
      redirectToGatewayLogin('/adapter/user-dashboard')
    }

    return {
      reasonText,
      messageText,
      description,
      retry,
    }
  },
})
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 460px;
  background: #ffffff;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.heading {
  font-weight: 700;
  font-size: 28px;
  color: #333;
  margin-bottom: 18px;
}

.desc {
  color: #666;
  line-height: 1.7;
  margin-bottom: 16px;
}

.detail {
  color: #8c8c8c;
  line-height: 1.7;
  margin-bottom: 10px;
  word-break: break-word;
}

.login-button {
  width: 100%;
  height: 45px !important;
  margin-top: 12px;
}
</style>
